import { useTranslation } from 'react-i18next';
import { Col } from 'react-bootstrap';
import classNames from 'classnames';

const Title = () => {
  const { t } = useTranslation();
  const isEmbedded = new URLSearchParams(window.location.search).has('embed');

  return (
    <Col xs={12} style={{ maxWidth: 920 }}>
      <h2
        className={classNames(
          'fw-bold fs-2 fs-md-1 mb-2',
          {
            'mt-5': !isEmbedded
          }
        )}
      >
        {t('ticketHeader.ticketTitle')}
      </h2>
      <p className="text-gray mb-lg-3">{t('ticketHeader.ticketDescription')}</p>
    </Col>
  );
};

export default Title;
